import React, { useState } from 'react';
import { useAppContext } from '../../contexts/AppContext';
import { useSearchContext } from '../../contexts/SearchContext';
import { useNavigate } from 'react-router-dom';
import EnquireNowModal from '../../components/Popup/EnquireNowPopup';
import { Rate } from '../../../../backend/src/models/rateHawkModels/hotelPageResponseModel';
import { HotelDataInfo } from '../../../../backend/src/models/rateHawkModels/hotelDataInfo';

type Props = {
  hotelId: string;
  //pricePerNight: number;
  //packageType: string;
  //depositPrice: string;
  //destId: string;
  hotelName: string;
  slug: string;
  //propertyToken: string;
  //roomsAndBoard: string;
  //cancellation: string;
  onSelect: (room: Rate) => void;
  price: string;
  book_hash: string;
  hotel: HotelDataInfo;
  date: string;
};

const GuestInfoForm: React.FC<Props> = ({ price, hotelName, slug, date, book_hash, hotel }) => {
  const { user } = useAppContext();
  const { guests } = useSearchContext();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false); 
 
  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const totalAdults = guests.reduce((sum, g) => sum + g.adults, 0);
  const totalChildren = guests.reduce((sum, g) => sum + g.children.length, 0);

  const handleBookingStart = () => {
    // Navigate to the booking form page and pass the data via `state`
    navigate(`/booking/${book_hash}`, {
      state: {
        //destId,
        book_hash,
        primaryGuestName: `${user?.firstName} ${user?.lastName}`,
        numAdults: totalAdults,
        numChilds: totalChildren,
        totalCost: price,
        //hotel: hotel,
        bookingType: '',
        hold: '',
        date: date,
        hotel: hotel.data
      },
    });
  };

  return (
    <div className="mx-auto mt-4">
    <div className="flex flex-col lg:flex-row gap-4">
        <div className="bg-white w-full order-1 lg:order-2">
          {price === '0.00' ? 
            (<button
              type="button"
              className="bg-halo-pink text-white h-full py-2 px-4 font-medium hover:bg-pink-800 text-md w-full rounded-lg"
              onClick={openModal}
            >
              Inquire Now
            </button>)
          :
            (<button
                type="button"
                className="bg-halo-pink text-white h-full py-2 px-4 font-medium hover:bg-pink-800 text-md w-full rounded-lg"
                onClick={handleBookingStart}
            >
                Continue
            </button>)
          }
        </div>
    </div>
    {showModal && <EnquireNowModal closeModal={closeModal} hotelName={hotelName} slug={slug}/>}
</div>
  );
};

export default GuestInfoForm;
